<template>
  <section style="width: 100%">
    <a v-if="0" :href="travelWebLink" target="_blank">Travel Web Link</a>
    <div
      :class="[
        'card-header weblink_card__header',
        isItineraryCancelled
          ? 'box__disabled'
          : isOpenWeblinkTab
          ? 'card-open'
          : '',
      ]"
      role="button"
      @click="toggleWebItinerary"
    >
      <p class="card-header-title">Weblink / Web Itinerary</p>
      <div
        v-if="
          this.$route.query.itinerary !== undefined && !hideElementByCondition
        "
        class="card-header-icon"
      >
        <a
          v-if="!isOpenWeblinkTab && isSavable"
          :class="focusedGuideBoxClass('button button-saas', 47, false)"
          :disabled="isExportToWeblinkDisabled"
        >
          <i
            class="button is-color4 is-danger button-saas is-radius is-size is-small"
          >
            <IconPencil class="icon is-small" />
          </i>
        </a>
        <a v-if="isOpenWeblinkTab && canEditWeblink" class="ml-5 color-11">
          <i class="button button-saas button-info is-size is-small mr-0">
            <IconClose class="icon is-small color-11" />
          </i>
          Cancel
        </a>
      </div>
      <div
        class="weblink__buttons is-flex is-justify-content-space-between is-align-items-center"
      >
        <BaseButton
          v-if="isOpenWeblinkTab && isSavable"
          :disabled="!canSaveExport"
          size="medium"
          action="tercery"
          data-action-type="EXPORT:ITINERARY_EXPORT_SAVE"
          @click="onlySaveExportChanges"
        >
          <IconCheck slot="icon" class="icon is-small" />
          <p slot="text">Save</p>
        </BaseButton>

        <div
          v-if="!canEditWeblink && hasLinkCode"
          class="copy__link__container mr-3"
        >
          <b-icon
            size="is-small"
            custom-size="mdi-18px"
            icon="link"
            class="mx-2"
          ></b-icon>

          <p
            v-if="!canEditWeblink"
            style="
              display: inline-block;
              cursor: pointer;
              text-decoration: underline;
            "
            @click="openItinerary"
          >
            {{ getWeblinkLink() }}
          </p>

          <b-button @click="copyWeblinkLink"> Copy </b-button>
        </div>

        <ExportToWeblinkButton
          :can-edit-weblink="canEditWeblink"
          :has-link-code="hasLinkCode"
          :disabled="isExportToWeblinkDisabled || !hasLinkCode"
          :export-preview="
            () => {
              exportPreview();
              finishTourGuide();
            }
          "
        />
      </div>
    </div>
    <b-collapse
      :class="`card mb-2 ${isOpenWeblinkTab ? 'show' : ''}`"
      :open="isOpenWeblinkTab"
      animation="slide"
      @open="isOpenWeblinkTab"
    >
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Here you can select a template to show your quotation, please select the one you like the most"
        :step="48"
        :position-x="350"
        :position-y="-110"
        :show-next-button="false"
        :show-back-button="false"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Here you can also select what content you want to show in your Weblink"
        :step="49"
        :position-x="350"
        :position-y="150"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="You can press here if you want to hide travel dates in your Weblink"
        :step="50"
        :position-x="220"
        :position-y="340"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="You can press here if you want to hide the list of services in your Weblink"
        :step="51"
        :position-x="480"
        :position-y="340"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Here you can add photos that you want to show in your Weblink"
        :step="52"
        :position-x="350"
        :position-y="350"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Let's add one photo to your Weblink, click on 'Add Photo'"
        :step="53"
        :position-x="20"
        :position-y="380"
        :show-next-button="false"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Great!, you have added a photo to your Weblink"
        :step="56"
        :position-x="20"
        :position-y="360"
        :show-back-button="false"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="Now you can add more photos or publish your Weblink"
        :step="57"
        :position-x="20"
        :position-y="360"
        :primary-button-action="handleScroll"
      />
      <GuideBox
        v-if="!loading"
        title="Editing the Weblink"
        description="As the last step, you can publish your Weblink clicking on 'Publish/Open'"
        :step="58"
        :position-x="420"
        :position-y="0"
        :show-next-button="false"
      />
      <div class="card-content">
        <div
          v-if="!isExperience"
          :class="focusedGuideBoxClass('template-cards mb-5', 48, true)"
        >
          <p class="has-text-weight-bold template-card-title mb-2">
            Select a template
          </p>
          <div class="carousel__container">
            <div
              v-for="template in templates"
              :key="template.id"
              :class="[
                templateOption === template.id ? 'active' : '',
                'border-radius-20 is-flex p-2 w-40 template__card',
              ]"
            >
              <div class="PhotoImage sideBar" @click="nextStep()">
                <img :src="template.image_cover" :alt="template.name" />
                <b-radio
                  v-model="templateOption"
                  name="name"
                  :native-value="Number(template.id)"
                  class="card__content"
                  :disabled="!canSaveExport || hideElementByCondition"
                >
                  {{ template.name }}
                </b-radio>
              </div>
            </div>
          </div>
        </div>
        <ExportAccordionColors
          v-if="isTemplateSelectedAvailableToEdit() && !isExperience"
          :template-colors="templateColors"
          @update="updateColors"
        />
        <div
          v-if="!isExperience"
          :class="focusedGuideBoxClass('template-cards', 49, true)"
        >
          <p class="has-text-weight-bold template-card-title mb-4">
            Select content
          </p>
          <p class="template-card-title mb-2">
            Choose the content you want to show in your Weblink
          </p>
          <div class="block is-flex export_config_contents__container">
            <div class="mr-5">
              <p class="has-text-weight-semibold template-card-title mb-2">
                Sections
              </p>
              <div
                :class="
                  focusedGuideBoxClass(
                    'checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2',
                    50,
                    true
                  )
                "
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_TRAVEL_DATES"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  >Travel dates
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_ITINERARY"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  >Itinerary
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.ITINERARY_DESCRIPTION"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  >Description
                </b-checkbox>
              </div>
              <div
                v-if="authConfig.serviceConfigEnabled"
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_HOTELS_ACCOMMODATIONS"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  @input.native="
                    () =>
                      checkConfigOptions(
                        false,
                        templateConfig.DISPLAY_HOTELS_ACCOMMODATIONS
                      )
                  "
                  >Accommodations/Hotels
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_CONTACT_US"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  >Contact Us
                </b-checkbox>
              </div>
            </div>
            <div v-if="authConfig.serviceConfigEnabled" class="mr-5">
              <p class="has-text-weight-semibold template-card-title mb-2">
                Service List
              </p>
              <div
                :class="
                  focusedGuideBoxClass(
                    'checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2',
                    51,
                    true
                  )
                "
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_SERVICE_LIST"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  @input="() => checkConfigOptions(false)"
                  >Service list
                </b-checkbox>
              </div>
              <div
                v-if="hasViewServiceListWithPricesPermission"
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-tooltip
                  position="is-bottom"
                  type="is-warning"
                  class="tooltip__warning"
                  multilined
                  :active="serviceListWithPricesConditions.length > 0"
                >
                  <b-checkbox
                    v-model="configOptions"
                    :native-value="
                      templateConfig.DISPLAY_SERVICE_LIST_WITH_PRICES
                    "
                    size="is-small"
                    :disabled="
                      serviceListWithPricesConditions.length > 0 ||
                      !canSaveExport ||
                      hideElementByCondition
                    "
                  >
                    Service list with prices
                  </b-checkbox>
                  <template v-slot:content>
                    <ul class="tooltip__list">
                      <li
                        v-for="condition in serviceListWithPricesConditions"
                        :key="condition"
                      >
                        {{ condition }}
                      </li>
                    </ul>
                  </template>
                </b-tooltip>
              </div>
              <div
                :class="
                  focusedGuideBoxClass(
                    'checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2',
                    51,
                    true
                  )
                "
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_OPTIONALS_WITH_PRICES"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  @input.native="
                    () =>
                      checkConfigOptions(
                        false,
                        templateConfig.DISPLAY_OPTIONALS_WITH_PRICES
                      )
                  "
                >
                  Optionals with prices
                </b-checkbox>
              </div>
            </div>
            <div>
              <p class="has-text-weight-semibold template-card-title mb-2">
                Prices Level
              </p>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_COMFORT_LEVEL"
                  size="is-small"
                  :disabled="
                    !canSaveExport ||
                    hideElementByCondition ||
                    isLevelDisabled(constants.SERVICE_LEVELS.COMFORT.id)
                  "
                  @input="
                    () =>
                      checkConfigOptions(
                        true,
                        templateConfig.DISPLAY_COMFORT_LEVEL
                      )
                  "
                >
                  {{
                    getPriceLevelLabelById(constants.SERVICE_LEVELS.COMFORT.id)
                  }}
                  level
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_SUPERIOR_LEVEL"
                  size="is-small"
                  :disabled="
                    !canSaveExport ||
                    hideElementByCondition ||
                    isLevelDisabled(constants.SERVICE_LEVELS.SUPERIOR.id)
                  "
                  @input="
                    () =>
                      checkConfigOptions(
                        true,
                        templateConfig.DISPLAY_SUPERIOR_LEVEL
                      )
                  "
                >
                  {{
                    getPriceLevelLabelById(constants.SERVICE_LEVELS.SUPERIOR.id)
                  }}
                  level
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_LUXURY_LEVEL"
                  size="is-small"
                  :disabled="
                    !canSaveExport ||
                    hideElementByCondition ||
                    isLevelDisabled(constants.SERVICE_LEVELS.LUXURY.id)
                  "
                  @input="
                    () =>
                      checkConfigOptions(
                        true,
                        templateConfig.DISPLAY_LUXURY_LEVEL
                      )
                  "
                >
                  {{
                    getPriceLevelLabelById(constants.SERVICE_LEVELS.LUXURY.id)
                  }}
                  level
                </b-checkbox>
              </div>
              <div
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_PRICES"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  @input.native="
                    () =>
                      checkConfigOptions(false, templateConfig.DISPLAY_PRICES)
                  "
                >
                  Prices Levels
                </b-checkbox>
              </div>
              <div
                v-if="hasViewPaymentMethodsPermission"
                class="checkbox-container border-radius-20 p-1 pt-2 pl-2 mb-2"
              >
                <b-checkbox
                  v-model="configOptions"
                  :native-value="templateConfig.DISPLAY_PAYMENT_GATEWAY"
                  size="is-small"
                  :disabled="!canSaveExport || hideElementByCondition"
                  @input.native="
                    () =>
                      checkConfigOptions(
                        false,
                        templateConfig.DISPLAY_PAYMENT_GATEWAY
                      )
                  "
                >
                  Payment Methods
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div :class="focusedGuideBoxClass('mb-5 mt-5 content', 52, true)">
          <p class="has-text-weight-bold template-card-title mb-2">
            Select Images
          </p>
          <div
            class="columns w-100 mb-0 mt-1 export_photos__container"
            :disabled="!canSaveExport || hideElementByCondition"
          >
            <div
              v-for="imageType in templateImages"
              :key="imageType.type"
              class="column is-centered"
            >
              <b-tooltip
                :label="`${imageType.label} image`"
                type="is-info"
                position="is-bottom"
              >
                <div
                  class="PhotoImage sideBar"
                  style="width: 10.5rem; height: 8rem"
                >
                  <img
                    v-if="
                      imageType.images_full && imageType.images_full.length > 0
                    "
                    :src="imageType.images_full[0].thumbnail_350X240"
                    :alt="imageType.images_full[0].name"
                  />

                  <div v-else class="placeholder__image">
                    <p>{{ imageType.label }} Image</p>
                  </div>
                </div>
              </b-tooltip>
              <div class="flex-center">
                <AssetsContainer
                  class="pt-2"
                  :location-path-prop="getAssetPath(imageType)"
                  :form-with-images="[imageType]"
                  :category="imageType.category"
                  type="export"
                  :multiple="false"
                  :allow-empty="true"
                  :assets-searching-payload="
                    getAssetsSearchingPayloadByImageType(
                      imageType,
                      assetsSearchingPayload
                    )
                  "
                  :validate-function-execution="validateFunctionExecution"
                  @update="updateImages"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!hideElementByCondition"
          class="is-flex is-justify-content-flex-end"
        >
          <ExportToWeblinkButton
            :can-edit-weblink="canEditWeblink"
            :has-link-code="hasLinkCode"
            :disabled="isExportToWeblinkDisabled"
            :export-preview="
              () => {
                exportPreview();
                finishTourGuide();
              }
            "
          />
        </div>
      </div>
    </b-collapse>

    <br />

    <div
      v-if="!hideElementByCondition"
      role="button"
      :class="`card-header export_word__container ${
        isItineraryCancelled ? 'box__disabled' : ''
      }`"
    >
      <p class="card-header-title">Word / Text Processor</p>
      <ExportToWordButton />
    </div>

    <br />

    <hr style="background-color: #aaa" />

    <div
      v-if="!hideElementByCondition && isEnabledByTenant"
      role="button"
      class="card-header external_export_tab"
      style="display: flex; justify-content: space-between"
    >
      <div class="w-100">
        <div class="mb-2" style="display: block">
          <p v-if="isAlreadyExported" class="card-header-title">
            <IconCheckCircle /> Exported to
            <strong class="has-text-capitalize ml-1">{{
              itineraryExternalSource
            }}</strong>
          </p>
          <div v-else-if="isExportingToExternal">
            <p class="card-header-title">
              <span class="loading_circle__icon mr-2"></span> Exporting
              <strong class="has-text-capitalize ml-1">{{
                itineraryExternalSource
              }}</strong>
            </p>

            <span class="is-block mt-4">
              If the export hasn't completed after 10-15 minutes, please refresh
              the page.
            </span>
          </div>
          <p v-else class="card-header-title pl-0">Export to External Source</p>
        </div>
        <div class="pb-2 is-flex is-justify-content-space-between w-100">
          <div>
            <p>
              <IconWarning
                v-if="!accountOnOtherSystem"
                class="icon_warning"
                style="width: 1.2rem; height: 1.2rem"
              />
              <span class="has-text-weight-semibold">User: </span>
              {{ accountOnOtherSystem ? ownerExternalCode : "No" }}
            </p>
            <p class="mt-2">
              <span class="has-text-weight-semibold">Code: </span>
              {{
                itineraryExternalCode.length > 0
                  ? itineraryExternalCode
                  : "Please wait 10 to 15 minutes after confirming"
              }}
            </p>
            <p
              v-if="!isAlreadyExported || itineraryExternalUrl.length > 0"
              class="mt-2"
            >
              <span class="has-text-weight-semibold">Link(Oppen): </span>
              <a
                v-if="itineraryExternalUrl.length > 0"
                class="has-text-underline"
                :href="itineraryExternalUrl"
                target="_blank"
              >
                {{ itineraryExternalUrl }}
              </a>
              <span v-else>
                Please wait 10 to 15 minutes after confirming
              </span>
            </p>
            <p v-if="!isAlreadyExported && !isItineraryConfirmed" class="mt-2">
              <IconWarning
                class="icon_warning"
                style="width: 1.2rem; height: 1.2rem"
              />
              <span class="has-text-weight-semibold py-4">Important:</span>
              To export a quote, it must first be confirmed.
            </p>
          </div>
          <div>
            <button
              v-if="exportToExternalButtonEnable"
              :disabled="loading || !hasAccountOnOtherSystem"
              class="button-outline button is-color2 color2"
              @click="onExternalExportClick"
            >
              <i class="mr-4"><IconExport class="icon is-small" /></i>
              Export Itinerary
            </button>
            <ExternalExportModal
              :is-modal-open="showExternalExportModal"
              :loading="loading"
              :on-external-export-continue="onExternalExportContinue"
              :close-modal="closeExternalExportModal"
            />
          </div>
        </div>
      </div>
    </div>

    <ExportWeblinkAndStatusAlert
      :is-open="isExportWeblinkAndStatusAlertOpen"
      :status-to-change="statusToChange"
      :set-loading="handleLoading"
      :on-cancel="onExportWeblinkAndStatusAlertCancel"
      :on-continue="onExportWeblinkAndStatusAlertContinue"
      @update:isOpen="isExportWeblinkAndStatusAlertOpen = $event"
    />
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import AssetsContainer from "../../_shared/AssetsContainer.vue";
import GuideBox from "@/components/_shared/GuideBox.vue";
import ExternalExportModal from "@/components/quote-views/_shared/ExternalExportModal.vue";
import {
  TEMPLATE_CONFIG,
  SERVICE_LIST_WITH_PRICES_CONDITIONS,
  getTemplateImagesDefault,
  EXPORT_IMAGES_TYPES,
} from "@/constants/exportConfig";
import ExportToWordButton from "./ExportToWordButton.vue";
import ExportAccordionColors from "./ExportAccordionColors.vue";
import ExportWeblinkAndStatusAlert from "./ExportWeblinkAndStatusAlert.vue";
import * as utils from "@/utils/itinerary";
import { CATEGORY_ASSET, PERMISSION, USER_ROLE } from "@/constants";
import { exportHelper } from "@/utils/export";
import helpers from "@/helpers";
import { ITINERARY_STATUS, QUOTES_STATUS } from "@/constants/itinerary";
import { SERVICE_LEVELS } from "@/constants/services";
import { serviceHelper } from "@/utils/service";
import { helper } from "@/utils/itinerary";
import { buildWebLink } from "@/utils/utils";
import ExportToWeblinkButton from "@/components/quote-views/export/ExportToWeblinkButton.vue";

export default {
  name: "ExportAccordion",
  components: {
    ExportToWeblinkButton,
    AssetsContainer,
    GuideBox,
    ExportToWordButton,
    ExportAccordionColors,
    ExternalExportModal,
    ExportWeblinkAndStatusAlert,
  },
  props: {
    isExperience: {
      type: Boolean,
      default: false,
    },
    published_images_config: {
      type: [Array, Object],
      default: () => [],
    },
    templateColors: {
      type: Array,
      default: () => [],
    },
    templateImages: {
      type: Array,
      default: () => [],
    },
    isOpenWeblinkTab: {
      type: Boolean,
      default: false,
    },
    setIsOpenWeblinkTab: {
      type: Function,
      default: () => {},
    },
    handleLoading: {
      type: Function,
      default: () => {},
    },
    loadPublishedImagesItinerary: {
      type: Function,
      default: () => {},
    },
    finishTourGuide: {
      type: Function,
      default: () => {},
    },
    validateFunctionExecution: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      helper: { ...exportHelper },
      constants: {
        SERVICE_LEVELS,
        QUOTES_STATUS,
      },
      templateConfig: TEMPLATE_CONFIG,
      utils: utils,
      showExternalExportModal: false,
      configOptions: [],
      templateOption: 1,
      isExportWeblinkAndStatusAlertOpen: false,
      assetsSearchingPayload: {
        country: null,
        destination: null,
      },
    };
  },
  watch: {
    isExperience() {
      this.$emit(
        "update:templateImages",
        getTemplateImagesDefault(this.isExperience)
      );
    },
    published_images_config: {
      handler() {
        this.assetsSearchingPayload = utils.helper.getLocationOnMount(
          this.quoteServices?.[0]?.location,
          this.contractLocations
        );
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      countries: "client/getCountriesFromContract",
      itinerary: "itinerary/getItinerary",
      itineraryStatus: "itinerary/getItineraryStatus",
      templates: "itinerary/getWebTemplates",
      isUserGuideActive: "userguide/getIsUserGuideActive",
      userGuideStep: "userguide/getStep",
      authData: "auth/getAuthData",
      authConfig: "auth/authConfig",
      disableQuoteByStatus: "itinerary/getDisableQuoteByStatus",
      loading: "utils/getLoading",
      quoteServices: "itinerary/getServicesItinerary",
      isRecentlyExported: "itinerary/getIsRecentlyExported",
      itineraryPaxPrices: "itinerary/getPaxPrices",
      hideElementByCondition: "itinerary/getHideElementByCondition",
      quotePrices: "itinerary/getPricesItineraries",
      quoteStatuses: "status_itinerary/getQuoteStatuses",
      pricesLevels: "itinerary/getPricesLevelsWithAllOption",
      hasAccountOnOtherSystem: "itinerary/getHasAccountOnOtherSystem",
      contractLocations: "client/getCountriesFromContract",
      isEnabledByTenant: "itinerary/getIsEnabledByTenant",
    }),
    travelWebLink() {
      if (!this.itinerary?.data?.link_code) return null;
      const short_code = this.itinerary.data.link_code.split("/").pop();
      return "https://dev.d38x8rsjfcf6v7.amplifyapp.com/program/" + short_code;
    },
    isSavable() {
      return (
        this.canEditWeblink &&
        (!this.utils.helper.hasStatus(this.itineraryStatus, [
          QUOTES_STATUS.UNDER_REVIEW.id,
        ]) ||
          this.isAdminSupport)
      );
    },
    canEditWeblink() {
      return !(
        this.utils.helper.hasStatus(this.itineraryStatus, [
          QUOTES_STATUS.CONFIRMED.id,
          QUOTES_STATUS.SENT.id,
          QUOTES_STATUS.PUBLISHED.id,
        ]) && !this.isItineraryCancelled
      );
    },
    statusToChange() {
      const quoteStatusesIds = this.quoteStatuses.map((status) => status.id);

      const hasSentStatus = quoteStatusesIds.includes(QUOTES_STATUS.SENT.id);

      return hasSentStatus
        ? QUOTES_STATUS.SENT.name
        : QUOTES_STATUS.PUBLISHED.name;
    },
    canSaveExport() {
      return utils.helper.hasStatus(this.itineraryStatus, [
        QUOTES_STATUS.IN_PREPARATION.id,
        QUOTES_STATUS.UNDER_REVIEW.id,
        QUOTES_STATUS.READY_TO_SELL.id,
        QUOTES_STATUS.READY_TO_PUBLISH.id,
      ]);
    },
    isExportToWeblinkDisabled() {
      const enabledByStatus = utils.helper.hasStatus(this.itineraryStatus, [
        QUOTES_STATUS.IN_PREPARATION.id,
        QUOTES_STATUS.UNDER_REVIEW.id,
        QUOTES_STATUS.SENT.id,
        QUOTES_STATUS.CONFIRMED.id,
        QUOTES_STATUS.PUBLISHED.id,
        QUOTES_STATUS.READY_TO_SELL.id,
        QUOTES_STATUS.READY_TO_PUBLISH.id,
      ]);

      return this.loading || !enabledByStatus;
    },
    isItineraryCancelled() {
      return this.itineraryStatus === ITINERARY_STATUS.CANCEL.value;
    },
    itineraryExternalSource() {
      return this.itinerary?.data?.external_source?.trim() || "";
    },
    itineraryExternalCode() {
      return this.itinerary?.data?.external_code?.trim() || "";
    },
    itineraryExternalUrl() {
      return this.itinerary?.data?.external_url?.trim() || "";
    },
    ownerExternalCode() {
      return this.itinerary?.data?.owner?.external_code ?? "";
    },
    accountOnOtherSystem() {
      return this.ownerExternalCode.length > 0;
    },
    isAvailableToExternalExport() {
      return (
        this.accountOnOtherSystem &&
        this.itineraryStatus === ITINERARY_STATUS.CONFIRM.value &&
        !this.isRecentlyExported
      );
    },
    isExportingToExternal() {
      return this.itinerary.exporting?.includes(this.itinerary.data?.id);
    },
    isAlreadyExported() {
      return this.itineraryExternalCode.length > 0;
    },
    isItineraryConfirmed() {
      return this.itineraryStatus === ITINERARY_STATUS.CONFIRM.value;
    },
    exportToExternalButtonEnable() {
      return (
        this.isAvailableToExternalExport &&
        !this.isAlreadyExported &&
        !this.isExportingToExternal
      );
    },
    hasViewPaymentMethodsPermission() {
      if (this.authData.tenant.name !== "ela") return false;

      return !helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
    hasViewServiceListWithPricesPermission() {
      if (this.hasViewSalePricePermission) return true;

      return this.isAdminSupport;
    },
    isAdminSupport() {
      return helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.ADMIN, USER_ROLE.SUPPORT],
        true
      );
    },
    hasViewSalePricePermission() {
      return serviceHelper.hasAnyViewPermissions(
        this.authData,
        this.itinerary,
        [PERMISSION.VIEW_SALE_PRICE]
      );
    },
    serviceListWithPricesConditions() {
      const conditions = Object.values(SERVICE_LIST_WITH_PRICES_CONDITIONS);
      const hasHiddenItineraryServices =
        this.getHiddenItineraryServices().length > 0;
      const hasFee = this.validateIfQuoteHasFee();
      const hasUpsale = this.validateIfQuoteHasUpsale();

      const disableServiceListWithPrices =
        hasHiddenItineraryServices || hasFee || hasUpsale;

      if (!disableServiceListWithPrices) return [];

      return conditions.filter((condition) => {
        if (
          this.itinerary.data.client.external_code !== "NL-OUT" &&
          condition ===
            SERVICE_LIST_WITH_PRICES_CONDITIONS.NO_HIDDEN_SERVICES &&
          hasHiddenItineraryServices
        )
          return condition;
        if (condition === SERVICE_LIST_WITH_PRICES_CONDITIONS.NO_FEE && hasFee)
          return condition;
        if (
          condition === SERVICE_LIST_WITH_PRICES_CONDITIONS.NO_UPSALE &&
          hasUpsale
        )
          return condition;
      });
    },
    hasLinkCode() {
      return ![null, undefined].includes(this.itinerary?.data?.link_code);
    },
  },
  mounted() {
    this.getWebTemplates();

    this.assetsSearchingPayload = utils.helper.getLocationOnMount(
      this.quoteServices?.[0]?.location,
      this.contractLocations
    );

    if (this.published_images_config.config) {
      this.templateOption = this.published_images_config.config.id_template
        ? this.published_images_config.config.id_template
        : 1;
      if (
        this.published_images_config.config.contents &&
        this.published_images_config.config.contents.length
      ) {
        const contents = this.published_images_config.config.contents;
        this.setConfigOptions(contents.map((content) => content.id_content));
      }
    }
  },
  methods: {
    getAssetsSearchingPayloadByImageType(imageType, assetsSearchingPayload) {
      const validatedPayload = !assetsSearchingPayload?.country
        ? utils.helper.getLocationOnMount(
            this.quoteServices?.[0]?.location,
            this.contractLocations
          )
        : assetsSearchingPayload;

      const response = {
        country:
          imageType.type === EXPORT_IMAGES_TYPES.LOGO
            ? null
            : validatedPayload?.country,
        destination:
          imageType.type === EXPORT_IMAGES_TYPES.LOGO
            ? null
            : validatedPayload?.destination,
      };

      return response;
    },
    getPriceLevelLabelById(id) {
      return this.pricesLevels.find((level) => level.level === id)?.label || "";
    },
    copyWeblinkLink() {
      const weblinkLink = this.getWeblinkLink();
      if (!weblinkLink) return;

      navigator.clipboard.writeText(weblinkLink).then(
        () => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Weblink link copied to clipboard!",
            position: "is-top",
            type: "is-success",
          });
        },
        () => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Failed to copy Weblink link!",
            position: "is-top",
            type: "is-danger",
          });
        }
      );
    },
    openExportWeblinkAndStatusAlert() {
      this.isExportWeblinkAndStatusAlertOpen = true;
    },
    closeExportWeblinkAndStatusAlert() {
      this.isExportWeblinkAndStatusAlertOpen = false;
    },
    isLevelDisabled(level) {
      const validation = (service) =>
        [level, SERVICE_LEVELS.ALL.id].includes(service.level);

      const hasServices = this.quoteServices.filter(validation).length > 0;

      const hasPriceGreaterThanZero =
        this.quotePrices?.[0]?.prices.find(
          (priceLevel) => priceLevel.level === level
        )?.total > 0;

      return !hasServices || !hasPriceGreaterThanZero;
    },
    closeExternalExportModal() {
      this.showExternalExportModal = false;
    },
    async onExternalExportContinue(externalSource = "") {
      this.handleLoading(true);
      this.closeExternalExportModal();
      await this.$store.dispatch("itinerary/setIsRecentlyExported", true);
      await this.$store.dispatch("itinerary/exportToExternal", {
        itineraryId: this.itinerary.data.id,
        externalSource,
      });
      await this.$store.dispatch("itinerary/setIsRecentlyExported", false);
      this.handleLoading(false);
    },
    async onExternalExportClick() {
      this.showExternalExportModal = true;
    },
    getHiddenItineraryServices() {
      return (
        this.quoteServices.filter(
          (itineraryService) => !itineraryService.visible
        ) || []
      );
    },
    validateIfQuoteHasFee() {
      return this.itineraryPaxPrices.some((itineraryPaxPrice) => {
        return itineraryPaxPrice.price_levels.some((priceLevel) => {
          return priceLevel.prices.some((price) => price.fee > 0);
        });
      });
    },
    validateIfQuoteHasUpsale() {
      return this.itineraryPaxPrices.some((itineraryPaxPrice) => {
        return itineraryPaxPrice.price_levels.some((priceLevel) => {
          return priceLevel.prices.some((price) => price.mkt_coin > 0);
        });
      });
    },
    getExportToOOTooltip() {
      if (this.isExportingToExternal) return "Your quote is exporting...";
      if (this.isAlreadyExported) return "Your quote was already exported!";
      return "Export to Open Orange";
    },
    async exportToExternal() {
      if (!this.isAvailableToExternalExport) {
        return this.$buefy.toast.open({
          duration: 5000,
          message: "The quote is not available to do an external export!",
          position: "is-top",
          type: "is-danger",
        });
      }
      if (this.isAlreadyExported) {
        return this.$buefy.toast.open({
          duration: 5000,
          message: "The quote is already exported!",
          position: "is-top",
          type: "is-warning",
        });
      }
      if (this.isExportingToExternal) {
        return this.$buefy.toast.open({
          duration: 5000,
          message: "The quote is already exporting!",
          position: "is-top",
          type: "is-warning",
        });
      }
      this.handleLoading(true);
      await this.$store.dispatch("itinerary/setIsRecentlyExported", true);
      await this.$store.dispatch(
        "itinerary/exportToExternal",
        this.itinerary.data.id
      );
      await this.$store.dispatch("itinerary/setIsRecentlyExported", false);
      this.handleLoading(false);
      return this.$buefy.toast.open({
        duration: 10000,
        message: "The quote was successfully exported!",
        position: "is-top",
        type: "is-success",
      });
    },
    updateImages(newTemplateImages) {
      const defaultImages = getTemplateImagesDefault();
      this.$emit(
        "update:templateImages",
        this.templateImages.map((templateImage) => {
          const found = newTemplateImages.find(
            (newTemplateImage) => newTemplateImage.type === templateImage.type
          );
          if (found) {
            const defaultImage = defaultImages.find(
              (defaultImage) => defaultImage.type === found.type
            );
            return {
              ...found,
              images_full:
                found.images_full.length > 0
                  ? found.images_full
                  : defaultImage.images_full,
            };
          }
          return templateImage;
        })
      );
    },
    getAssetPath(imageType) {
      if (this.itinerary.data === undefined) return "";

      if (imageType.category === CATEGORY_ASSET.CLIENT)
        return `CLIENT-${this.itinerary.data.client.id}`;

      return utils.getLocationsPath(this.countries);
    },
    toggleWebItinerary() {
      if (this.$route.query.itinerary === undefined) return;

      this.setIsOpenWeblinkTab(!this.isOpenWeblinkTab);
      this.nextStep();
    },
    setConfigOptions(newConfigOptions = []) {
      if (newConfigOptions.length === 0) {
        this.configOptions = [];
        return;
      }
      this.configOptions = newConfigOptions;
    },
    checkConfigOptions(fromLevels = false, templateConfigSelected = null) {
      const {
        DISPLAY_OPTIONALS_WITH_PRICES,
        DISPLAY_PRICES,
        DISPLAY_HOTELS_ACCOMMODATIONS,
        DISPLAY_PAYMENT_GATEWAY,
        DISPLAY_COMFORT_LEVEL,
        DISPLAY_LUXURY_LEVEL,
        DISPLAY_SUPERIOR_LEVEL,
        DISPLAY_SERVICE_LIST,
      } = TEMPLATE_CONFIG;

      const somePriceLevelSelected = this.configOptions.some((item) =>
        [
          DISPLAY_COMFORT_LEVEL,
          DISPLAY_LUXURY_LEVEL,
          DISPLAY_SUPERIOR_LEVEL,
        ].includes(item)
      );

      const isSelectingSomePriceLevel = [
        DISPLAY_COMFORT_LEVEL,
        DISPLAY_LUXURY_LEVEL,
        DISPLAY_SUPERIOR_LEVEL,
      ].includes(templateConfigSelected);

      if (isSelectingSomePriceLevel && !somePriceLevelSelected) {
        this.configOptions = this.configOptions.filter(
          (item) => ![DISPLAY_PAYMENT_GATEWAY].includes(item)
        );
      }

      const includesOptionalsWithPrices = this.configOptions.includes(
        DISPLAY_OPTIONALS_WITH_PRICES
      );
      const includesPriceLevels = this.configOptions.includes(DISPLAY_PRICES);
      const includesHotels = this.configOptions.includes(
        DISPLAY_HOTELS_ACCOMMODATIONS
      );
      const includesPaymentGateway = this.configOptions.includes(
        DISPLAY_PAYMENT_GATEWAY
      );

      const unselectingOptionalsWithPrices =
        templateConfigSelected === DISPLAY_OPTIONALS_WITH_PRICES &&
        includesOptionalsWithPrices &&
        includesPaymentGateway;
      const unselectingPricesLevels =
        templateConfigSelected === DISPLAY_PRICES &&
        includesPriceLevels &&
        includesPaymentGateway;
      const unselectingHotels =
        templateConfigSelected === DISPLAY_HOTELS_ACCOMMODATIONS &&
        includesHotels &&
        includesPaymentGateway;

      if (
        unselectingOptionalsWithPrices ||
        unselectingHotels ||
        unselectingPricesLevels
      ) {
        this.configOptions = this.configOptions.filter(
          (item) => item !== DISPLAY_PAYMENT_GATEWAY
        );
      }

      if (
        templateConfigSelected === DISPLAY_PAYMENT_GATEWAY &&
        !includesPaymentGateway &&
        (!includesOptionalsWithPrices ||
          !includesPriceLevels ||
          !includesHotels)
      ) {
        this.configOptions = [
          ...this.configOptions,
          ...[
            DISPLAY_OPTIONALS_WITH_PRICES,
            DISPLAY_PRICES,
            DISPLAY_HOTELS_ACCOMMODATIONS,
          ].filter((item) => !this.configOptions.includes(item)),
        ];
      }

      if (!somePriceLevelSelected && !fromLevels) {
        const filteredLevels = [
          {
            level: SERVICE_LEVELS.COMFORT.id,
            configOption: DISPLAY_COMFORT_LEVEL,
          },
          {
            level: SERVICE_LEVELS.SUPERIOR.id,
            configOption: DISPLAY_SUPERIOR_LEVEL,
          },
          {
            level: SERVICE_LEVELS.LUXURY.id,
            configOption: DISPLAY_LUXURY_LEVEL,
          },
        ].filter((item) => !this.isLevelDisabled(item.level));

        this.configOptions = [
          ...this.configOptions,
          ...filteredLevels.map((item) => item.configOption),
        ];
      } else if (!somePriceLevelSelected && fromLevels) {
        this.configOptions = this.configOptions.filter(
          (item) =>
            ![DISPLAY_SERVICE_LIST, DISPLAY_HOTELS_ACCOMMODATIONS].includes(
              item
            )
        );
      }
    },
    updateConfig() {
      const config = this.published_images_config.config
        ? { ...this.published_images_config.config }
        : {};
      config.id_template = this.templateOption;
      if (!config.id) {
        config.id = null;
      }

      const contents = [];
      this.configOptions.forEach((content) => {
        const existsConfigOption = contents.find(
          (item) => item.id_content === content
        );
        if (typeof content === "number" && !existsConfigOption) {
          contents.push({
            id: null,
            id_content: content,
          });
        }
      });

      if (config.contents && config.contents.length) {
        config.contents.forEach((content) => {
          const finIndexContent = contents.findIndex(
            (item) => item.id_content === content.id_content
          );
          if (finIndexContent !== -1) {
            contents[finIndexContent].id = content.id;
          } else {
            contents.push({
              ...content,
              status: -1,
            });
          }
        });
      }

      config.contents = contents;
      return config;
    },
    async onlySaveExportChanges() {
      try {
        this.handleLoading(true);
        await this.saveAndPublish();
        this.handleLoading(false);
        this.$buefy.toast.open({
          duration: 5000,
          message: "The data was successfully updated!",
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        this.$buefy.toast.open({
          duration: 5000,
          message: error.response?.data?.message
            ? error.response.data.message
            : "Can't save changes.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
    async handleSaveImagesAndConfig(payload) {
      const config = this.updateConfig();
      let adaptedPayload = {
        id: this.$route.query.itinerary,
        data: {
          images: [],
          config,
        },
        cur_step: payload?.cur_step || 1,
        last_step: payload?.last_step || 1,
      };

      const newImages = this.templateImages.map((item) => {
        const imageIds = item.images_full
          .map((image) => image.id)
          .filter((id) => id != null)
          .join(",");

        return {
          type: item.type,
          id: item.id,
          images: "{" + imageIds + "}",
        };
      });

      adaptedPayload.data.images = [
        ...adaptedPayload.data.images,
        ...newImages,
      ];
      adaptedPayload.data.config.colors =
        this.helper.getColorsWithoutDuplicated(this.templateColors);

      return this.$store
        .dispatch("itinerary/publishConfigAndImages", adaptedPayload)
        .then((response) => {
          if (response) {
            this.$buefy.toast.open({
              duration: 5000,
              message: "The data was successfully updated!",
              position: "is-top",
              type: "is-success",
            });
            this.loadPublishedImagesItinerary();
            return response;
          }
        })
        .catch((error) => {
          this.$buefy.toast.open({
            duration: 5000,
            message: error.message,
            position: "is-top",
            type: "is-danger",
          });
          throw error;
        });
    },
    getWeblinkLink() {
      return buildWebLink(this.itinerary?.data?.link_code);
    },
    openItinerary() {
      const weblinkUrl = this.getWeblinkLink();
      window.open(weblinkUrl, "_blank", "");
    },
    publishItinerary(payload) {
      if (this.$route.query.itinerary) {
        const adaptedPayload = {
          data: {
            id: this.$route.query.itinerary,
          },
          cur_step: payload?.cur_step || 1,
          last_step: payload?.last_step || 1,
        };
        return this.$store.dispatch("itinerary/publish", adaptedPayload);
      } else {
        this.$router.push("/");
      }
    },
    closeWebItineraryAccordion() {
      this.setIsOpenWeblinkTab(false);
    },
    async changeQuoteStatus(newStatus, params = {}) {
      const selectedItinerary = this.$route.query.itinerary;

      if (!selectedItinerary) return;

      const payload = {
        id: selectedItinerary,
        status: newStatus,
        ...params,
      };

      await this.$store.dispatch("itinerary/change_status", payload);
    },
    validateExportWeblinkAndStatusAlert() {
      if (this.isExportWeblinkAndStatusAlertOpen) return false;

      const couldQuoteStatusBeChanged = helper.hasStatus(this.itineraryStatus, [
        QUOTES_STATUS.IN_PREPARATION.id,
        QUOTES_STATUS.READY_TO_SELL.id,
      ]);

      if (couldQuoteStatusBeChanged) {
        this.handleLoading(true);
        return false;
      }

      return true;
    },
    async onExportWeblinkAndStatusAlertCancel() {
      this.handleLoading(true);

      await this.publishItineraryAndOpenWeblinks();

      this.closeExportWeblinkAndStatusAlert();

      this.handleLoading(false);
    },
    async onExportWeblinkAndStatusAlertContinue() {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.handleLoading(true);

          await this.publishItineraryAndOpenWeblinks({
            cur_step: 1,
            last_step: 3,
          });

          await this.changeQuoteStatus(QUOTES_STATUS.SENT.id, {
            cur_step: 3,
            last_step: 3,
          });

          this.closeExportWeblinkAndStatusAlert();

          this.handleLoading(false);
        },
        functionToExecuteOnFail: async (error) => {
          this.handleLoading(false);
          throw error;
        },
      });
    },
    validateOnlyOpenWeblink() {
      return !this.canEditWeblink;
    },
    exportPreview() {
      if (this.itinerary?.data) {
        const weblinkUrl = buildWebLink(
          `${this.itinerary.data.link_code}?token=${this.authData.token}`
        );

        window.open(weblinkUrl, "_blank", "");
      }
    },
    async publishItineraryAndOpenWeblinks(params = {}) {
      return await this.$store.dispatch("utils/validateFunctionExecution", {
        functionToExecute: async () => {
          this.handleLoading(true);

          if (this.validateOnlyOpenWeblink()) {
            this.openItinerary();
            return this.handleLoading(false);
          }

          if (this.validateExportWeblinkAndStatusAlert()) {
            return this.handleLoading(false);
          }

          this.closeWebItineraryAccordion();

          //await this.changeQuoteStatus(QUOTES_STATUS.SENT.id);

          const response = await this.saveAndPublish(params);
          if (response) {
            this.handleLoading(false);
            this.$buefy.toast.open({
              duration: 5000,
              message: response.message,
              position: "is-top",
              type: "is-success",
            });

            this.exportPreview();
          }
        },
        functionToExecuteOnFail: async (error) => {
          this.handleLoading(false);

          await this.$store.dispatch("itinerary/setQuoteExportFailedAlert", {
            isOpen: true,
            title: error?.response?.data?.message,
            items: serviceHelper.adaptServiceExportErrors(
              error?.response?.data?.errors,
              this.$route.query.itinerary
            ),
          });
        },
      });
    },
    async saveAndPublish(params = {}) {
      await this.handleSaveImagesAndConfig({
        cur_step: params?.cur_step || 1,
        last_step: params?.last_step || 2,
      });

      return await this.publishItinerary({
        cur_step: params?.cur_step + 1 || 2,
        last_step: params?.last_step || 2,
      });
    },
    async getWebTemplates() {
      await this.$store.dispatch("itinerary/getWebTemplates");
    },
    focusedGuideBoxClass(
      classDefault,
      step,
      bgWhite = false,
      extraValidator = null
    ) {
      const bgWhiteClass = bgWhite ? "bg-white" : "";
      const checkStep = step.length
        ? step.includes(this.userGuideStep)
        : this.userGuideStep === step;
      const resultExtraValidator = !extraValidator || extraValidator();
      return this.isUserGuideActive &&
        checkStep &&
        !this.loading &&
        resultExtraValidator
        ? `${classDefault} is-guide-step ${bgWhiteClass}`
        : classDefault;
    },
    nextStep() {
      if (this.isUserGuideActive) this.$store.dispatch("userguide/nextStep");
    },
    handleScroll() {
      scroll(0, 100);
    },
    updateColors({ key = "", value = "" }) {
      const newColors = this.templateColors.map((color) => {
        return {
          ...color,
          value: color.type === key ? value : color.value,
        };
      });
      const mainKey = "updateColors";
      this.$emit("update", { key: mainKey, value: newColors });
    },
    isTemplateSelectedAvailableToEdit() {
      const templatesAvaialableToEdit = this.templates
        .filter((template) => template.id === 1)
        .map((template) => template.id);
      return templatesAvaialableToEdit.includes(this.templateOption);
    },
  },
};
</script>

<style>
.is-centered {
  text-align: center;
}
.flex-center {
  display: flex;
  justify-content: space-around;
}
.word-card-images {
  justify-content: space-around;
}
.word-card-image {
  max-width: 200px;
  max-height: 250px;
}
.word-card-image-empty {
  width: 200px;
  background: white;
}
.template-card {
  border: 2px solid var(--gray-600);
  justify-content: space-between;
  margin: 2rem auto;
  width: fit-content;
  filter: grayscale(100%);
}
.template-card.active {
  border-color: var(--secondary-color);
  filter: none;
}
.card-header {
  padding: 0;
  border-radius: 15px !important;
  border-bottom: 0;
}
.publish.color-11 {
  transition: transform 0.3s, border 0.3s, background 0.3s, color 0.3s;
}
.publish.color-11:hover {
  color: var(--info-color) !important;
}
.checkbox-container {
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 15%),
    0 0 0 1px rgb(10 10 10 / 2%);
  width: max-content;
}
.carousel-arrow .icon {
  color: #fff;
  border: #fff;
}
.carousel-list.has-shadow {
  box-shadow: none;
}
.carousel-list {
  width: 100%;
  gap: 2rem;
  margin: 0 auto;
}
.carousel-slides {
  overflow-x: scroll;
}
.carousel-slides::-webkit-scrollbar {
  height: 0.8rem;
}
.carousel-slide {
  margin: 0 2rem;
  max-width: 15rem;
  min-width: 15rem;
}
.PhotoImage.sideBar img {
  height: 10rem;
}
.PhotoImage {
  justify-content: center;
  align-items: center;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.card__content {
  padding: 1rem 0;
}
.carousel__container {
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  padding-top: 3rem;
}
.carousel__container .active {
  border: 2px solid var(--secondary-color);
  border-radius: 0px 0px 20px 20px !important;
  position: relative;
}
.carousel__container .active::after {
  content: "Selected ✔";
  position: absolute;
  left: 0;
  top: -2rem;
  width: 100%;
  border: 1px solid #f00b81;
  outline: 2px solid #f00b81;
  text-align: center;
  color: #fff;
  background-color: #f00b81;
  border-radius: 0.8rem 0.8rem 0 0;
  padding: 0.25rem 0;
}
.external_export_tab {
  padding: 1rem;
}
.external_export_tab[is-disabled="true"] {
  opacity: 0.6;
  cursor: no-drop;
}
.external_export_tab[is-disabled="true"] .card-header-icon,
.external_export_tab[is-disabled="true"] button {
  opacity: 0.6 !important;
  cursor: no-drop !important;
}
.external_export_tab .icon_warning > svg,
.external_export_tab p > svg {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.5rem;
  color: #198754;
}
.external_export_tab .icon_warning {
  color: #ff9316;
}
.box__disabled {
  background: #eaeaef;
  border: 1px solid #666687;
  opacity: 0.99 !important;
  cursor: no-drop;
  pointer-events: none;
}
.tooltip__warning.b-tooltip.is-multiline.is-medium .tooltip-content {
  width: 18rem;
}
.tooltip__list {
  padding-left: 1rem;
}
.tooltip__list,
.tooltip__list li {
  list-style: disc;
  text-align: left;
}
.loading_circle__icon {
  border-radius: 50%;
  border: 2px dashed #ff9316;
  width: 1rem;
  height: 1rem;
}
.weblink_card__header {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}
.card-header-title,
.card-header-icon {
  padding: 0;
}
.export_word__container {
  padding: 1rem;
}
.card-open .weblink__buttons {
  display: flex;
  margin-left: 1rem;
  gap: 1rem;
}
.card-open .weblink__buttons .field {
  margin-bottom: 0rem;
}
.card-header {
  box-shadow: 0 0 0.25em rgba(10, 10, 10, 0.1);
}

.copy__link__container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #1d3b83;
  border-radius: 0.5rem;
  padding: 0.25rem;
  gap: 0.5rem;
}

.copy__link__container button,
.copy__link__container button:focus,
.copy__link__container button:hover {
  background-color: #1d3b83;
  border-radius: 0.5rem;
  color: #fff;
  font-size: 0.8rem;
}

@media screen and (max-width: 480px) {
  .card-open.weblink_card__header {
    flex-wrap: wrap;
    row-gap: 1rem;
  }
  .weblink__buttons i.button {
    width: 1rem !important;
    height: 1.25rem !important;
    margin-right: 0.5rem;
  }
  .card-header {
    padding: 1rem;
  }
  .PhotoImage.sideBar {
    min-width: 12rem;
    height: 8rem;
  }
  .PhotoImage.sideBar img {
    width: 100%;
    height: 100%;
  }
  .card-open .weblink__buttons {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-left: 0rem;
  }
  .card-content {
    width: 100%;
  }
  .export_config_contents__container {
    flex-direction: column;
    row-gap: 1rem;
    margin-top: 1rem;
  }
  .export_photos__container {
    display: flex;
    overflow-x: auto;
    margin: 0rem;
  }
}
</style>
